<script lang="ts">
	import ProductsSlider from '$lib/components/ProductsSlider.svelte'
	import { is_set_array } from '$lib/js/helpers'
	import { storeRecentSearches, storeSearchedText } from '$lib/js/stores'
	import { page } from '$app/state'
	import { t } from 'svelte-i18n-lingui'
	import { onMount } from 'svelte'
	import { goto } from '$app/navigation'
	import type { BaseProduct, FullProduct } from '$lib/js/elasticsearch/types'
	import { getContextScope } from '$lib/js/helpers/i18n'
	import { getMoreProducts } from '$lib/js/products'

	const scope = getContextScope()
	const defaultSearches = [
		'perfume',
		'juego',
		'vajilla',
		'silla',
		'asiento',
	]

	let recommended_products: (BaseProduct | FullProduct)[] = $state([])

	onMount(() => {
		(async () => {
			if (page.data.category?.id) {
				recommended_products = await getRecommendedProdsByCat()
			} else {
				recommended_products = await getRecommendedProds()
			}
		})()
	})

	async function getRecommendedProds() {
		const skus = [
			'B12YND7KWH', 'S3723198', 'B18N6JAXFZ', 'B1254FGV4Z', 'B1CESLS582', 'B19QS6WVXW',
			'B1AFYCBRQG', 'B1DCNRJZJT', 'B12RKP2N26', 'B14PQNCGEB', 'B1454XXZMF', 'B1H2P5WN2H',
			'SLC-81948', 'S05100792', 'B15QLEFVHM', 'B1GS5X3NA2', 'B1JC96TYTE',
		]

		const recommended = await fetch(`/${scope}/endpoints/sku_products`, {
			method: 'POST',
			body: JSON.stringify(skus),
			headers: {
				'Content-Type': 'application/json',
			},
		})
		const products = await recommended.json() as (BaseProduct | null)[]
		return products.filter(product => product !== null) as BaseProduct[]
	}

	async function getRecommendedProdsByCat() {
		return await getMoreProducts({
			start: 0,
			sort: {
				rating_average: { order: 'desc' },
				reviews_number: { order: 'desc' },
			},
			size: 16,
			min_price: 0,
			max_price: 200000,
			search_text: $storeSearchedText,
			cat_id: page.data.category.id,
		}, 'category', {scope: scope})
	}

	async function executeRecentSearch(search: string) {
		$storeSearchedText = search
		goto(`${page.url.pathname}?search=${search}`)
	}
</script>


<div class="search-modal__popular">
	{#if is_set_array($storeRecentSearches)}
		<h2 class="head-4">{$t`Recent searches`}</h2>
		<ul>
			{#each $storeRecentSearches as search}
				<li>
					<button onclick={() => executeRecentSearch(search)}>{search}</button>
				</li>
			{/each}
		</ul>
	{:else}
		<h2 class="head-4">{$t`Most searched`}</h2>
		<ul>
			{#each defaultSearches as search}
				<li>
					<button onclick={() => executeRecentSearch(search)}>{search}</button>
				</li>
			{/each}
		</ul>
	{/if}
</div>

{#if is_set_array(recommended_products)}
	<div class="search-modal__recommended">
		<ProductsSlider products={recommended_products} type="search" />
	</div>
{/if}


<style lang="scss">
  .search-modal {
    &__popular {
      padding: 0 15px;

      @media (min-width: 1025px) {
        width: 220px;
        padding: 20px 0 0;
      }

      h2 {
        @media (max-width: 1024px) {
          margin-bottom: 5px;
        }
      }

      ul {
        width: 100%;

        @media (max-width: 1024px) {
          display: flex;
          flex-wrap: wrap;
          column-gap: 15px;
          row-gap: 5px;
          margin-bottom: 15px;
        }

        button {
          @media (min-width: 1025px) {
            font-size: 16px;
            padding-bottom: 3px;
          }
        }
      }
    }

    &__recommended {
      padding: 0 15px;

      @media (min-width: 1025px) {
        padding: 0;
        width: calc(100% - 280px);
      }
    }
  }
</style>
